import { lazy, Suspense } from 'react';
import { useParams } from 'react-router-dom';
import LazyLoading from '../../../components/LazyLoading';

export const LazyOdv = lazy(() =>
  import(
    /* webpackChunkName: 'Update Sales opening configuration' */ './index'
  ),
);

export default function Odv(props) {
  const { id } = useParams();

  return (
    <Suspense fallback={<LazyLoading />}>
      <LazyOdv {...props} id={id} />
    </Suspense>
  );
}
